<div class="document-component-container">
  <div
    class="attribute-editor-component"
    rvSpinner="document-editor-loader"
    [rvShowSpinner]="spinner"
  >
    <div class="document-component-settings te-scrollable-container">
      @if (revokeFailed) {
        <div class="attribute-editor-row">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <div class="text-sm">
                  We could not revoke your access with Microsoft at this time.
                  We strongly recommend you manually revoke access in your
                  Microsoft account.
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (authenticateFailed) {
        <div class="attribute-editor-row">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group has-error">
                <p class="help-block">
                  <span
                    >Sorry, there's an issue with authentication or the
                    authentication window was blocked by the browser. Please try
                    clicking the "Select from Microsoft OneDrive" button
                    again.</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      }

      <basic-uploader
        [uploaderId]="fileUploaderId + '-uploader'"
        [uploadManager]="storageUploadManager"
        [validType]="fileType"
        [shown]="isUploading"
      >
      </basic-uploader>

      <!-- Select from UI-->
      @if (!source && !isUploading) {
        <div class="attribute-editor-row">
          <div class="row">
            <div class="col-xs-12">
              <div class="document-source-container form-group">
                <label>Choose a Powerpoint Source</label>
                <button
                  matButton="outlined"
                  class="tw-w-full tw-mb-2.5 button-role--provider"
                  (click)="selectFromOneDrive()"
                >
                  <mat-icon
                    svgIcon="integration-microsoft"
                    aria-hidden="true"
                  ></mat-icon>
                  <span>Select from Microsoft OneDrive</span>
                </button>

                <button
                  matButton="outlined"
                  class="tw-w-full tw-mb-2.5 button-role--provider"
                  (click)="selectFromStorage()"
                >
                  <mat-icon
                    svgIcon="cloud-storage"
                    aria-hidden="true"
                  ></mat-icon>
                  <span>Select from Storage</span>
                </button>

                @if (currentPlanService.isPlanActive()) {
                  <button
                    matButton="outlined"
                    class="tw-w-full tw-mb-2.5 button-role--provider"
                    (click)="uploadFromComputer()"
                  >
                    <mat-icon
                      svgIcon="upload-square"
                      aria-hidden="true"
                    ></mat-icon>
                    <span>Upload from Computer</span>
                  </button>
                } @else {
                  <button
                    id="upload-file-unsubscribed"
                    matButton="outlined"
                    class="tw-w-full tw-mb-2.5 button-role--provider"
                    (click)="currentPlanService.showUnlockThisFeatureModal()"
                  >
                    <mat-icon
                      svgIcon="upload-square"
                      aria-hidden="true"
                    ></mat-icon>
                    Upload from Computer
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Connected Account & File Options UI-->
      @if (source && !isUploading) {
        <div class="attribute-editor-row">
          <div class="row">
            <div class="col-xs-12">
              @if (provider === 'ms-graph') {
                <label>Connected Account:</label>
              }
              @if (provider === 'rise-storage') {
                <label>My Powerpoint File</label>
              }
              <div class="provider-connected-container form-group">
                @if (provider === 'ms-graph') {
                  <div class="account-info">
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/2/25/Microsoft_icon.svg"
                      alt="Microsoft"
                      class="account-logo"
                    />
                    <span class="account-email">{{
                      componentAccountUsername
                    }}</span>
                  </div>
                }
                <div class="provider-connected-file-info">
                  <div class="file-details">
                    <mat-icon
                      class="large tw-mr-2.5"
                      aria-hidden="true"
                      svgIcon="component-power-point"
                    ></mat-icon>
                    <div class="file-text">
                      <span class="file-title">{{ selectedName }}</span>
                      <span class="file-item-count"
                        >{{ values.assetCount }} slides</span
                      >
                    </div>
                  </div>
                  <button
                    class="btn btn-icon pr-0"
                    mat-icon-button
                    [matMenuTriggerFor]="fileOptions"
                    (menuOpened)="onDropdownOpen()"
                  >
                    <i
                      class="fa fa-chevron-down file-options-icon"
                      [ngClass]="{ clicked: isDropdownOpen }"
                    ></i>
                  </button>
                  <mat-menu
                    #fileOptions="matMenu"
                    xPosition="before"
                    (closed)="onDropdownClose()"
                  >
                    <button mat-menu-item (click)="changeFile()">
                      <streamline-icon
                        aria-hidden="true"
                        class="mr-3 streamline-component-icon"
                        name="fileInverted"
                        width="16"
                        height="16"
                      ></streamline-icon>
                      <span>Change File</span>
                    </button>
                    @if (provider === 'ms-graph') {
                      <button mat-menu-item (click)="openInPowerPoint()">
                        <streamline-icon
                          aria-hidden="true"
                          class="mr-3 streamline-component-icon"
                          name="arrowDiagonalRight"
                          width="16"
                          height="16"
                        ></streamline-icon>
                        <span>Open in PowerPoint</span>
                      </button>
                      @if (sameAccount) {
                        <hr class="m-2" />
                        <button mat-menu-item (click)="disconnect()">
                          <streamline-icon
                            aria-hidden="true"
                            class="mr-3 streamline-component-icon"
                            name="unlink"
                            width="16"
                            height="16"
                          ></streamline-icon>
                          <span>Disconnect from Microsoft</span>
                        </button>
                      }
                    }
                  </mat-menu>
                </div>
              </div>
            </div>
          </div>
        </div>

        @if (fileAccessFailed || values.fileMissing || conversionError) {
          <div class="attribute-editor-row">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <div class="provider-file-error has-error">
                    <streamline-icon
                      aria-hidden="true"
                      class="error-icon mr-3"
                      name="xmark"
                      width="24"
                      height="24"
                    ></streamline-icon>
                    <div>
                      @if (fileAccessFailed || values.fileMissing) {
                        <p class="help-block mt-1 font-weight-bold">
                          Uh oh! We can't find your file.
                        </p>
                        <p>
                          It looks like it might have been moved or deleted.
                          Select another file to update your presentation.
                        </p>
                      } @else if (conversionError) {
                        <p class="help-block mt-1 font-weight-bold">
                          Uh oh! The file could not be converted for use in the
                          presentation.
                        </p>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <div class="attribute-editor-row">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>Show each page for:</label>
                <div class="input-group">
                  <input
                    type="number"
                    id="document-component-duration"
                    class="form-control"
                    [(ngModel)]="values.duration"
                    (change)="saveDuration()"
                  />
                  <span class="input-group-addon">Seconds</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="attribute-editor-row">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label
                  id="document-component-transition-label"
                  class="control-label u_margin-sm-top"
                  >Transitions:</label
                >
                <mat-form-field
                  appearance="outline"
                  subscriptSizing="dynamic"
                  class="tw-w-full"
                >
                  <mat-select
                    id="document-component-transition"
                    [(ngModel)]="values.transition"
                    (selectionChange)="saveTransition()"
                    aria-labelledby="document-component-transition-label"
                  >
                    <mat-option value="">No Transition</mat-option>
                    <mat-option value="fadeIn">Fade In</mat-option>
                    <mat-option value="slideFromLeft"
                      >Slide from left</mat-option
                    >
                    <mat-option value="slideFromRight"
                      >Slide from right</mat-option
                    >
                    <mat-option value="slideFromTop">Slide from top</mat-option>
                    <mat-option value="slideFromBottom"
                      >Slide from bottom</mat-option
                    >
                    <mat-option value="zoomIn">Zoom in</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        @if (provider === 'ms-graph') {
          <div class="attribute-editor-row">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label
                    id="document-component-refresh-label"
                    class="control-label u_margin-sm-top"
                    >Refresh Interval:</label
                  >
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="tw-w-full"
                  >
                    <mat-select
                      id="document-component-refresh"
                      [(ngModel)]="values.refresh"
                      (selectionChange)="saveRefresh()"
                      [compareWith]="sameStoredChoice"
                      aria-labelledby="document-component-refresh-label"
                    >
                      <mat-option value="60">1 Hour</mat-option>
                      <mat-option value="180">3 Hours</mat-option>
                      <mat-option value="360">6 Hours</mat-option>
                      <mat-option value="720">12 Hours</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
